import React from "react";
import { Link } from "react-router-dom";
import { trackCTAClick } from "../../utils/analytics";
import "../../styles/Home5.css";

// Replaces the old HowItWorks component. Same three promises, told as cards in
// the new system instead of alternating image/text rows — the dark page needs
// one rhythm, and the old section's stock imagery was the weakest thing on it.
//
// This is the only section that sells the product rather than the graph, so it
// carries the trial CTA.

const STEPS = [
  {
    n: "01",
    title: "Tell us about your body",
    body: "Your constitution, lifestyle, medications and health history. Not a quiz for its own sake — it is what decides whether you are shown the plant that suits you or the one that suits everybody.",
  },
  {
    n: "02",
    title: "Get a recipe built for your biology",
    body: "Plants, preparations, amounts and timings chosen for you, each one traceable back to the actions and references behind it. Interactions and cautions are surfaced, not buried.",
  },
  {
    n: "03",
    title: "See what moves the needle for you",
    body: "Track how you respond week to week. Herbs work slowly and memory is a poor instrument — a record is what turns a recommendation into something you know works for your body.",
  },
];

const HowSection = () => (
  <section className="sv-dark sv-section how">
    <div className="sv-wrap">
      <h2 className="sv-h2 sv-center how__title">
        Your biology, not the average body
      </h2>
      <p className="sv-body sv-center how__intro">
        The same complaint in two people rarely points at the same plant. The
        Atlas is the evidence; this is how it becomes yours.
      </p>

      <ol className="sv-grid-3 how__steps">
        {STEPS.map((s) => (
          <li key={s.n} className="sv-card how__step">
            <span className="how__num">{s.n}</span>
            <h3 className="sv-h4">{s.title}</h3>
            <p className="sv-body how__body">{s.body}</p>
          </li>
        ))}
      </ol>

      <div className="sv-center how__actions">
        <Link
          to="/start?source=home-how"
          className="sv-btn sv-btn--primary"
          onClick={() => trackCTAClick("how_start_plan", "home-how")}
        >
          Get your personalized plan
        </Link>
      </div>
    </div>
  </section>
);

export default HowSection;
